import { render, staticRenderFns } from "./dataSearch.vue?vue&type=template&id=5b0d44ee&scoped=true&"
import script from "./dataSearch.vue?vue&type=script&lang=js&"
export * from "./dataSearch.vue?vue&type=script&lang=js&"
import style0 from "./dataSearch.vue?vue&type=style&index=0&id=5b0d44ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0d44ee",
  null
  
)

export default component.exports